import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import './projects.css';
import Carousel from '../carousel';
import Portauth1 from '../../images/Auditorium-AbuDhabi-Port-Authority-moov-group.webp';
import Portauth2 from '../../images/New_Pro_imgs/abudubai_port.jpeg';
import Portauth3 from '../../images/port-authority-project2.webp';
import Portauth4 from '../../images/port-authority-project3.webp';
import Portauth5 from '../../images/port-authority-project4.webp';
function portauthority() {
    return (

        <>
            <div className="boxed_wrapper" id="project">
                <Helmet>
                    <title>Auditorium Port Authority - Moov Group</title>
                    <meta name="description" content="" />
                    <meta property="og:title" content="Auditorium Port Authority" />
                    <meta property="og:description" content="" />
                    <meta property="og:image" content="../../images/moovgroup-office.webp" />
                    <link rel="canonical" href="https://www.moovgroup.com/auditorium-port-authority-acoustics" />
                    <link rel="alternate" href="https://www.moovgroup.com/auditorium-port-authority-acoustics" hreflang="en-GB" />
                </Helmet>
                <Header />
                <div id="moov">
                    <section className="breadcrumb-section projects-bg">
                        <div className="container">
                            <h1 className="page-title">Auditorium - Abu Dhabi Port</h1>
                            <span className="page-tag">Acoustic Design, Supply, Installation, Testing and Commissioning for The Complete Auditorium</span>
                        </div>
                    </section>

                    <section className="portfolio-section section-gap-top" id="portfolio">
                        <div className="container">

                            <div className="portfolio-items">
                                <div className="portfolio-item portfolio-style-four">

                                    <div className="row align-items-center">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-container1">
                                                <h1 className="portfolio-previous">Orbi theatre</h1>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-container2">
                                                <Link to="/orbi-theatre-acoustics" className="portfolio-next">Next &raquo;</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="line-footer"></span>
                                </div>
                            </div>

                            <div className="row portfolio-items portfolio-filter" id="portsub" style={{ position: "relative", height: "580px" }}>
                                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design web" style={{ position: "absolute", right: "0px", bottom: "0px" }}>
                                    <div className="portfolio-item">
                                        <div className="portfolio-thumb">
                                            <div className="thumb">
                                                <img src={Portauth1} alt="Port Authority Acoustics - 1" style={{height:"280px"}} />
                                            </div>
                                        </div>
                                        <div className="portfolio-desc">
                                            <span className="cat">Abu Dhabi</span>
                                            <h5 className="title"><Link to="/auditorium-port-authority-acoustics">Auditorium - Abu Dhabi Port</Link></h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 filter-item game" style={{ position: "absolute", right: "295px", bottom: "0px" }}>
                                    <div className="portfolio-item big-item">
                                        <div className="portfolio-thumb">
                                            <div className="thumb">
                                                <img src={Portauth2} alt="Port Authority Acoustics - 2" />
                                            </div>
                                        </div>
                                        <div className="portfolio-desc">
                                            <span className="cat">Abu Dhabi</span>
                                            <h5 className="title"><Link to="/auditorium-port-authority-acoustics">Auditorium - Abu Dhabi Port</Link></h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 filter-item web" style={{ position: "absolute", right: "885px", bottom: "0px" }}>
                                    <div className="portfolio-item">
                                        <div className="portfolio-thumb">
                                            <div className="thumb">
                                                <img src={Portauth3} alt="Port Authority Acoustics - 3" style={{height:"280px"}} />
                                            </div>
                                        </div>
                                        <div className="portfolio-desc">
                                            <span className="cat">Abu Dhabi</span>
                                            <h5 className="title"><Link to="/auditorium-port-authority-acoustics">Auditorium - Abu Dhabi Port</Link></h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design" style={{ position: "absolute", right: "0px", bottom: "290px" }}>
                                    <div className="portfolio-item">
                                        <div className="portfolio-thumb">
                                            <div className="thumb">
                                                <img src={Portauth4} alt="Port Authority Acoustics - 4" style={{height:"280px"}} />
                                            </div>
                                        </div>
                                        <div className="portfolio-desc">
                                            <span className="cat">Abu Dhabi</span>
                                            <h5 className="title"><Link to="/auditorium-port-authority-acoustics">Auditorium - Abu Dhabi Port</Link></h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 filter-item game web" style={{ position: "absolute", right: "885px", bottom: "290px" }}>
                                    <div className="portfolio-item">
                                        <div className="portfolio-thumb">
                                            <div className="thumb">
                                                <img src={Portauth5} alt="Port Authority Acoustics - 5" style={{height:"280px"}} />
                                            </div>
                                        </div>
                                        <div className="portfolio-desc">
                                            <span className="cat">Abu Dhabi</span>
                                            <h5 className="title"><Link to="/auditorium-port-authority-acoustics">Auditorium - Abu Dhabi Port</Link></h5>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="recently-project-style2-area">
                        <div className="container">
                            <div className="sec-title text-center">
                                <div className="pro-title">Our Projects</div>
                                <p className="bottom-text">we have successfully completed more than 900 acoustic projects<br /> over the last 17 years across the Middle East.<br /> Have a glance at our recently compeleted projects</p>
                            </div>
                            <Carousel />
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default portauthority;